export const SET_ENV = 'SET_ENV';
export const SET_ENV_TOKEN = 'SET_ENV_TOKEN';
export const SET_REFRESH = 'SET_REFRESH';
export const SET_ISNEW = 'SET_ISNEW';
